import { render, staticRenderFns } from "./support-channel.vue?vue&type=template&id=36b1e2eb&"
import script from "./support-channel.vue?vue&type=script&lang=js&"
export * from "./support-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports